import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b35606a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-body mt-3 d-flex flex-column justify-content-start align-content-start px-3" }
const _hoisted_2 = { class: "text-start mb-3" }
const _hoisted_3 = { class: "fs-4 fw-bold content-title" }
const _hoisted_4 = { class: "row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 row-cols-xl-4" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "align-self-end" }
const _hoisted_11 = { class: "demo-pagination-block mt-3 d-flex justify-content-end" }
const _hoisted_12 = { class: "mb-3 row row-cols-2 row-cols-sm-3" }
const _hoisted_13 = { class: "col text-start" }
const _hoisted_14 = { class: "ms-1" }
const _hoisted_15 = { class: "col text-start" }
const _hoisted_16 = { class: "ms-1" }
const _hoisted_17 = { class: "row row-cols-1 row-cols-sm-2" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "d-flex flex-column justify-content-start align-items-start mb-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-100 my-0" }, null, -1))
const _hoisted_21 = { class: "w-100 d-flex flex-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1" }, [
  /*#__PURE__*/_createTextVNode("(m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2"),
  /*#__PURE__*/_createTextVNode(")")
], -1))
const _hoisted_23 = { class: "ms-1" }
const _hoisted_24 = { class: "ms-1" }
const _hoisted_25 = { class: "ms-1" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "d-flex flex-column justify-content-start align-items-start mb-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-100 my-0" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1" }, [
  /*#__PURE__*/_createTextVNode("(m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2"),
  /*#__PURE__*/_createTextVNode(")")
], -1))
const _hoisted_30 = { class: "ms-1" }
const _hoisted_31 = { class: "ms-1" }
const _hoisted_32 = { class: "ms-1" }
const _hoisted_33 = { class: "dialog-footer" }
const _hoisted_34 = { class: "mb-3 row row-cols-2 row-cols-sm-3" }
const _hoisted_35 = { class: "col text-start" }
const _hoisted_36 = { class: "col text-start" }
const _hoisted_37 = { class: "row row-cols-1 row-cols-sm-2" }
const _hoisted_38 = { class: "col" }
const _hoisted_39 = { class: "d-flex flex-column justify-content-start align-items-start mb-3" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-100 my-0" }, null, -1))
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1 ms-sm-2" }, [
  /*#__PURE__*/_createTextVNode("(m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2"),
  /*#__PURE__*/_createTextVNode(")")
], -1))
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "ms-1 ms-sm-2" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "ms-1 ms-sm-2" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "ms-1 ms-sm-2" }
const _hoisted_49 = { class: "col" }
const _hoisted_50 = { class: "d-flex flex-column justify-content-start align-items-start mb-3" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-100 my-0" }, null, -1))
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1 ms-sm-2" }, [
  /*#__PURE__*/_createTextVNode("(m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2"),
  /*#__PURE__*/_createTextVNode(")")
], -1))
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "ms-1 ms-sm-2" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { class: "ms-1 ms-sm-2" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "ms-1 ms-sm-2" }
const _hoisted_60 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Operation = _resolveComponent("Operation")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_EditPen = _resolveComponent("EditPen")!
  const _component_ZoomIn = _resolveComponent("ZoomIn")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t("create_new_part_no")), 1)
      ]),
      _createVNode(_component_el_form, {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
        class: "mt-2",
        ref: "searchCriteriaFormRef",
        model: _ctx.searchCriteria,
        rules: _ctx.searchCriteriaFormRules,
        "label-position": 'right',
        "label-width": 'auto'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_form_item, {
                class: "w-100",
                tem: "",
                label: _ctx.t('form.label.top_pn')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchCriteria.topPNKeyword,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchCriteria.topPNKeyword) = $event)),
                    onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                    clearable: "",
                    placeholder: _ctx.t('placeholder.input')
                  }, null, 8, ["modelValue", "onKeyup", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_form_item, {
                class: "w-100",
                prop: "periodNum",
                label: _ctx.t('period') + ':'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchCriteria.periodNum,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchCriteria.periodNum) = $event)),
                    onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                    clearable: "",
                    placeholder: _ctx.t('placeholder.input')
                  }, null, 8, ["modelValue", "onKeyup", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClearSearchTopPNInfoClicked()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("clear")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSearchTopPNInfoClicked()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("search")), 1)
          ]),
          _: 1
        })
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_popover, {
            placement: "bottom",
            onHide: _ctx.onColDisplayCtrlPanelHidded,
            trigger: "click",
            Title: _ctx.t('column')
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, { link: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { size: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Operation)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[0],
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.colDisplayCtrl[0]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("top_pn")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[1],
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.colDisplayCtrl[1]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("period")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[2],
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.colDisplayCtrl[2]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("area_before_improvement")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[3],
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.colDisplayCtrl[3]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("area_after_improvement")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[4],
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.colDisplayCtrl[4]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("processing_leadtime_before_improvement")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[5],
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.colDisplayCtrl[5]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("processing_leadtime_after_improvement")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[6],
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.colDisplayCtrl[6]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("vender_leadtime_before_improvement")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[7],
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.colDisplayCtrl[7]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("vender_leadtime_after_improvement")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[8],
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.colDisplayCtrl[8]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("pph_before_improvement")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[9],
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.colDisplayCtrl[9]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("pph_after_improvement")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[10],
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.colDisplayCtrl[10]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("createDate")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[11],
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.colDisplayCtrl[11]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("modifiedDate")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["onHide", "Title"])
        ]),
        _createVNode(_component_el_table, {
          ref: "TopPNInfoTableRef",
          class: "w-100",
          data: _ctx.displayTopPNInfoList,
          stripe: true,
          onSortChange: _ctx.onSortChanged
        }, {
          default: _withCtx(() => [
            (_ctx.colDisplayCtrl[0])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  "min-width": "140",
                  sortable: "custom",
                  prop: "topPN",
                  label: _ctx.t('top_pn')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[1])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  "min-width": "100",
                  sortable: "custom",
                  prop: "periodNum",
                  align: "center",
                  label: _ctx.t('period')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[2])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 2,
                  "min-width": "140",
                  align: "center",
                  sortable: "custom",
                  prop: "areaBeforeImp",
                  label: _ctx.t('area_before_improvement')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[3])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 3,
                  "min-width": "140",
                  align: "center",
                  sortable: "custom",
                  prop: "areaAfterImp",
                  label: _ctx.t('area_after_improvement')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[4])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 4,
                  "min-width": "140",
                  align: "center",
                  sortable: "custom",
                  prop: "procLTBeforeImp",
                  label: _ctx.t('processing_leadtime_before_improvement')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[5])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 5,
                  "min-width": "140",
                  align: "center",
                  sortable: "custom",
                  prop: "procLTAfterImp",
                  label: _ctx.t('processing_leadtime_after_improvement')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[6])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 6,
                  "min-width": "160",
                  align: "center",
                  sortable: "custom",
                  prop: "venderLTBeforeImp",
                  label: _ctx.t('vender_leadtime_before_improvement')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[7])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 7,
                  "min-width": "160",
                  align: "center",
                  sortable: "custom",
                  prop: "venderLTAfterImp",
                  label: _ctx.t('vender_leadtime_after_improvement')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[8])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 8,
                  "min-width": "140",
                  align: "center",
                  sortable: "custom",
                  prop: "pphBeforeImp",
                  label: _ctx.t('pph_before_improvement')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[9])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 9,
                  "min-width": "140",
                  align: "center",
                  sortable: "custom",
                  prop: "pphAfterImp",
                  label: _ctx.t('pph_after_improvement')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[10])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 10,
                  "min-width": "220",
                  align: "center",
                  sortable: "custom",
                  prop: "createTime",
                  label: _ctx.t('createDate')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[11])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 11,
                  "min-width": "220",
                  align: "center",
                  sortable: "custom",
                  prop: "modifiedTime",
                  label: _ctx.t('modifiedDate')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, {
              width: "60",
              align: "center",
              label: _ctx.t('operation'),
              prop: "operate",
              class: "operateBtnGroup d-flex",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                (_ctx.userInfoStore.permissions.some((x) => x === 320))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      link: "",
                      type: "success",
                      onClick: ($event: any) => (_ctx.onEditTopPNInfoClicked(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_EditPen)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      link: "",
                      type: "primary",
                      onClick: ($event: any) => (_ctx.onViewTopPNInfoClicked(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ZoomIn)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data", "onSortChange"])
      ]),
      _createVNode(_component_el_row, {
        justify: "end",
        class: "mt-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_pagination, {
                  currentPage: _ctx.searchCriteria.page,
                  "onUpdate:currentPage": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.searchCriteria.page) = $event)),
                  "page-size": _ctx.searchCriteria.pageSize,
                  "onUpdate:page-size": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.searchCriteria.pageSize) = $event)),
                  "pager-count": _ctx.paginatorSetup.pagerCount,
                  layout: _ctx.paginatorSetup.layout,
                  small: _ctx.paginatorSetup.small,
                  "page-sizes": [20, 50, 100],
                  total: _ctx.filteredTotal,
                  onSizeChange: _ctx.onPagesizeChanged,
                  onCurrentChange: _ctx.onCurrentPageChanged,
                  justify: "end"
                }, null, 8, ["currentPage", "page-size", "pager-count", "layout", "small", "total", "onSizeChange", "onCurrentChange"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])), [
      [
        _directive_loading,
        _ctx.isTableLoading,
        void 0,
        {
          fullscreen: true,
          lock: true
        }
      ]
    ]),
    _createVNode(_component_el_dialog, {
      class: "top-pn-modify-dialog",
      top: _ctx.dialogTopVh,
      modelValue: _ctx.isShowModifyDialog,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.isShowModifyDialog) = $event)),
      title: _ctx.t('modify')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_33, [
          _createVNode(_component_el_button, {
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.isShowModifyDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onSaveModifyResultClicked()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          onSubmit: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["prevent"])),
          ref: "modifyTopPNInfoFormRef",
          model: _ctx.selectedTopPNInfo,
          rules: _ctx.modifyTopPNInfoFormRules,
          "label-position": _ctx.formLabelPosition,
          "label-width": _ctx.formLabelWidth
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", null, _toDisplayString(_ctx.t("form.label.period")), 1),
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.selectedTopPNInfo.periodNum), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", null, _toDisplayString(_ctx.t("form.label.top_pn")), 1),
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.selectedTopPNInfo.topPN), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("before_improvement")), 1),
                  _hoisted_20
                ]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "areaBeforeImp",
                  label: _ctx.t('form.label.area_before_improvement')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_el_input, {
                        class: "ms-3 ms-md-0 number_input_box",
                        precision: 1,
                        step: 0.1,
                        min: 0.0,
                        modelValue: _ctx.selectedTopPNInfo.areaBeforeImp,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedTopPNInfo.areaBeforeImp) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('placeholder.input')
                      }, null, 8, ["step", "min", "modelValue", "placeholder"]),
                      _hoisted_22
                    ])
                  ]),
                  _: 1
                }, 8, ["size", "label"]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "procLTBeforeImp",
                  label: _ctx.t('form.label.processing_leadtime_before_improvement')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "ms-3 ms-md-0 number_input_box",
                      precision: 0,
                      step: 1,
                      min: 0,
                      modelValue: _ctx.selectedTopPNInfo.procLTBeforeImp,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedTopPNInfo.procLTBeforeImp) = $event)),
                      clearable: "",
                      placeholder: _ctx.t('placeholder.input')
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createElementVNode("span", _hoisted_23, "(" + _toDisplayString(_ctx.t("day")) + ")", 1)
                  ]),
                  _: 1
                }, 8, ["size", "label"]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "venderLTBeforeImp",
                  label: _ctx.t('form.label.vender_leadtime_before_improvement')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "ms-3 ms-md-0 number_input_box",
                      precision: 0,
                      step: 1,
                      min: 0,
                      modelValue: _ctx.selectedTopPNInfo.venderLTBeforeImp,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selectedTopPNInfo.venderLTBeforeImp) = $event)),
                      clearable: "",
                      placeholder: _ctx.t('placeholder.input')
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createElementVNode("span", _hoisted_24, "(" + _toDisplayString(_ctx.t("day")) + ")", 1)
                  ]),
                  _: 1
                }, 8, ["size", "label"]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "pphBeforeImp",
                  label: _ctx.t('form.label.pph_before_improvement')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "ms-3 ms-md-0 number_input_box",
                      modelValue: _ctx.selectedTopPNInfo.pphBeforeImp,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.selectedTopPNInfo.pphBeforeImp) = $event)),
                      precision: 1,
                      step: 0.1,
                      min: 0.0,
                      clearable: "",
                      placeholder: _ctx.t('placeholder.input')
                    }, null, 8, ["modelValue", "step", "min", "placeholder"]),
                    _createElementVNode("span", _hoisted_25, "(" + _toDisplayString(_ctx.t("pcs")) + ")", 1)
                  ]),
                  _: 1
                }, 8, ["size", "label"])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("after_improvement")), 1),
                  _hoisted_28
                ]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "areaAfterImp",
                  label: _ctx.t('form.label.area_after_improvement')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "ms-3 ms-md-0 number_input_box",
                      precision: 1,
                      step: 0.1,
                      min: 0.0,
                      modelValue: _ctx.selectedTopPNInfo.areaAfterImp,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selectedTopPNInfo.areaAfterImp) = $event)),
                      clearable: "",
                      placeholder: _ctx.t('placeholder.input')
                    }, null, 8, ["step", "min", "modelValue", "placeholder"]),
                    _hoisted_29
                  ]),
                  _: 1
                }, 8, ["size", "label"]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "procLTAfterImp",
                  label: _ctx.t('form.label.processing_leadtime_after_improvement')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "ms-3 ms-md-0 number_input_box",
                      precision: 0,
                      step: 1,
                      min: 0,
                      modelValue: _ctx.selectedTopPNInfo.procLTAfterImp,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.selectedTopPNInfo.procLTAfterImp) = $event)),
                      clearable: "",
                      placeholder: _ctx.t('placeholder.input')
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createElementVNode("span", _hoisted_30, "(" + _toDisplayString(_ctx.t("day")) + ")", 1)
                  ]),
                  _: 1
                }, 8, ["size", "label"]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "venderLTAfterImp",
                  label: _ctx.t('form.label.vender_leadtime_after_improvement')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "ms-3 ms-md-0 number_input_box",
                      precision: 0,
                      step: 1,
                      min: 0,
                      modelValue: _ctx.selectedTopPNInfo.venderLTAfterImp,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.selectedTopPNInfo.venderLTAfterImp) = $event)),
                      clearable: "",
                      placeholder: _ctx.t('placeholder.input')
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createElementVNode("span", _hoisted_31, "(" + _toDisplayString(_ctx.t("day")) + ")", 1)
                  ]),
                  _: 1
                }, 8, ["size", "label"]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "pphAfterImp",
                  label: _ctx.t('form.label.pph_after_improvement')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "ms-3 ms-md-0 number_input_box",
                      modelValue: _ctx.selectedTopPNInfo.pphAfterImp,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.selectedTopPNInfo.pphAfterImp) = $event)),
                      precision: 1,
                      step: 0.1,
                      min: 0.0,
                      clearable: "",
                      placeholder: _ctx.t('placeholder.input')
                    }, null, 8, ["modelValue", "step", "min", "placeholder"]),
                    _createElementVNode("span", _hoisted_32, "(" + _toDisplayString(_ctx.t("pcs")) + ")", 1)
                  ]),
                  _: 1
                }, 8, ["size", "label"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules", "label-position", "label-width"])), [
          [
            _directive_loading,
            _ctx.isModifyDialogLoading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      ]),
      _: 1
    }, 8, ["top", "modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "top-pn-modify-dialog",
      top: _ctx.dialogTopVh,
      modelValue: _ctx.isShowViewDialog,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.isShowViewDialog) = $event)),
      title: _ctx.t('detail')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_60, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.isShowViewDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.selectedTopPNInfo,
          "label-position": _ctx.formLabelPosition,
          "label-width": _ctx.formLabelWidth
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("label", null, _toDisplayString(_ctx.t("form.label.period")), 1),
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedTopPNInfo.periodNum), 1)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("label", null, _toDisplayString(_ctx.t("form.label.top_pn")), 1),
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedTopPNInfo.topPN), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("before_improvement")), 1),
                  _hoisted_40
                ]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "areaBeforeImp",
                  label: _ctx.t('form.label.area_before_improvement')
                }, {
                  default: _withCtx(() => [
                    (_ctx.selectedTopPNInfo.areaBeforeImp)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.numeral(_ctx.selectedTopPNInfo.areaBeforeImp).format("0.0")), 1),
                          _hoisted_42
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["size", "label"]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "procLTBeforeImp",
                  label: _ctx.t('form.label.processing_leadtime_before_improvement')
                }, {
                  default: _withCtx(() => [
                    (_ctx.selectedTopPNInfo.procLTBeforeImp)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.numeral(_ctx.selectedTopPNInfo.procLTBeforeImp).format("0.0")), 1),
                          _createElementVNode("span", _hoisted_44, "(" + _toDisplayString(_ctx.t("day")) + ")", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["size", "label"]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "venderLTBeforeImp",
                  label: _ctx.t('form.label.vender_leadtime_before_improvement')
                }, {
                  default: _withCtx(() => [
                    (_ctx.selectedTopPNInfo.venderLTBeforeImp)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.numeral(_ctx.selectedTopPNInfo.venderLTBeforeImp).format("0.0")), 1),
                          _createElementVNode("span", _hoisted_46, "(" + _toDisplayString(_ctx.t("day")) + ")", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["size", "label"]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "pphBeforeImp",
                  label: _ctx.t('form.label.pph_before_improvement')
                }, {
                  default: _withCtx(() => [
                    (_ctx.selectedTopPNInfo.pphBeforeImp)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.numeral(_ctx.selectedTopPNInfo.pphBeforeImp).format("0.0")), 1),
                          _createElementVNode("span", _hoisted_48, "(" + _toDisplayString(_ctx.t("pcs")) + ")", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["size", "label"])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("after_improvement")), 1),
                  _hoisted_51
                ]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "areaAfterImp",
                  label: _ctx.t('form.label.area_after_improvement')
                }, {
                  default: _withCtx(() => [
                    (_ctx.selectedTopPNInfo.areaAfterImp)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.numeral(_ctx.selectedTopPNInfo.areaAfterImp).format("0.0")), 1),
                          _hoisted_53
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["size", "label"]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "procLTAfterImp",
                  label: _ctx.t('form.label.processing_leadtime_after_improvement')
                }, {
                  default: _withCtx(() => [
                    (_ctx.selectedTopPNInfo.procLTAfterImp)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.numeral(_ctx.selectedTopPNInfo.procLTAfterImp).format("0.0")), 1),
                          _createElementVNode("span", _hoisted_55, "(" + _toDisplayString(_ctx.t("day")) + ")", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["size", "label"]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "venderLTAfterImp",
                  label: _ctx.t('form.label.vender_leadtime_after_improvement')
                }, {
                  default: _withCtx(() => [
                    (_ctx.selectedTopPNInfo.venderLTAfterImp)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.numeral(_ctx.selectedTopPNInfo.venderLTAfterImp).format("0.0")), 1),
                          _createElementVNode("span", _hoisted_57, "(" + _toDisplayString(_ctx.t("day")) + ")", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["size", "label"]),
                _createVNode(_component_el_form_item, {
                  class: "mb-4",
                  size: _ctx.formItemSize,
                  prop: "pphAfterImp",
                  label: _ctx.t('form.label.pph_after_improvement')
                }, {
                  default: _withCtx(() => [
                    (_ctx.selectedTopPNInfo.pphAfterImp)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.numeral(_ctx.selectedTopPNInfo.pphAfterImp).format("0.0")), 1),
                          _createElementVNode("span", _hoisted_59, "(" + _toDisplayString(_ctx.t("pcs")) + ")", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["size", "label"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "label-position", "label-width"])
      ]),
      _: 1
    }, 8, ["top", "modelValue", "title"])
  ], 64))
}